// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightBoxPreview_wrapper__3VoeJ","thumbnail":"LightBoxPreview_thumbnail__xqKLl","hoverImage":"LightBoxPreview_hoverImage__264Zp","btn":"LightBoxPreview_btn__NTZ5d"};